const $ = jQuery.noConflict();

class AlumniSlider {
    constructor(sel, fade = false, asNavFor = false, outerEdgeLimit = false) {
        this.selector = sel;
        this.fade = fade;
        this.asNavFor = asNavFor;
        this.outerEdgeLimit = outerEdgeLimit;
    }

    init() {
        const {
            fade,
            asNavFor,
            outerEdgeLimit
        } = this;

        function slideSettings() {
            const _that = $(this);

            // add events to only one of two connected sliders
            if (_that.is('.block-alumni-slider__slider-content-inner')) {
                const arrows = _that.parent().find('.block-alumni-slider__arrow');
                const imagesWrapper = _that.parent().prev();
                const slideNumber = _that.parent().find('.block-alumni-slider__status span');

                _that.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
                    slideNumber.html(`${nextSlide + 1}`);
                });

                arrows.on('click', (e) => {
                    e.preventDefault();
                    arrows.attr('disabled', true);

                    if (imagesWrapper.hasClass('active')) {
                        return;
                    }

                    imagesWrapper.addClass('active');
                    const slides = imagesWrapper.find('.slick-slide');
                    slides.addClass('switch-out');

                    setTimeout(() => {
                        slides.removeClass('switch-out').addClass('switch-in');
                        setTimeout(() => {
                            if ($(e.delegateTarget).is('.block-alumni-slider__arrow-next')) {
                                _that.slick('slickNext');
                            } else {
                                _that.slick('slickPrev');
                            }

                            imagesWrapper.removeClass('active');
                            slides.removeClass('switch-in');

                            setTimeout(() => {
                                arrows.attr('disabled', false);
                            }, 600);
                        }, 100);
                    }, 600);
                });
            }

            _that.slick({
                dots: false,
                arrows: false,
                infinite: true,
                rows: 0,
                outerEdgeLimit,
                draggable: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor,
                fade
            });
        }

        $(this.selector).each(slideSettings);
    }
}

const AlumniSliderImage = new AlumniSlider('.block-alumni-slider__slider-images', true, '.block-alumni-slider__slider-content-inner');
const AlumniSliderText = new AlumniSlider('.block-alumni-slider__slider-content-inner', true, '.block-alumni-slider__slider-images');

export { AlumniSliderImage, AlumniSliderText };
